import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GroupsSharedModule } from '@app/groups/groups-shared.module';
import { MarkdownModule } from '@app/markdown/markdown.module';

import { OrgsSharedModule } from '@app/orgs/orgs-shared.module';
import { SharedModule } from '@app/shared/shared.module';
import { FollowTargetModal } from '@app/target/components/modals/follow-target-modal/follow-target-modal.component';
import { SharedTargetService } from '@app/target/services/shared-target.service';
import { TargetService } from '@app/target/services/target.service';
import { UploaderModule } from '@app/uploader/uploader.module';
import { UserModule } from '@app/user/user.module';
import { DfFormlyModule } from '@lib/fresco';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { TargetSettingsFormComponent } from './components/target-settings-form/target-settings-form.component';
import { TargetSharedModule } from './target-shared.module';
import { ContentCatalogSharedModule } from '@app/content-catalog/content-catalog-shared.module';

@NgModule({
  declarations: [FollowTargetModal, TargetSettingsFormComponent],
  imports: [
    CommonModule,
    NgbAccordionModule,
    SharedModule,
    DfFormlyModule.forRoot(),
    OrgsSharedModule,
    MarkdownModule,
    GroupsSharedModule,
    UploaderModule,
    UserModule,
    TargetSharedModule,
    ContentCatalogSharedModule,
  ],
  providers: [TargetService, SharedTargetService],
})
export class TargetModule {}
